import type { LatLon } from '@findmy/shared';

const coord = (p: LatLon) => `${p.lat.toFixed(6)},${p.lon.toFixed(6)}`;

/** OpenStreetMap directions to the device, from your position when it's known. */
export function osmDirections(to: LatLon, from: LatLon | null): string {
  const route = `${from ? coord(from) : ''};${coord(to)}`;
  return `https://www.openstreetmap.org/directions?route=${encodeURIComponent(route)}`;
}

export function googleDirections(to: LatLon, from: LatLon | null): string {
  const params = new URLSearchParams({ api: '1', destination: coord(to) });
  if (from) params.set('origin', coord(from));
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}
